module.exports = __webpack_public_path__ + "img/11.d0ed06aa.jpg";